var React = require('react');

function CalendarMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 6h1a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1V5a1 1 0 1 1 2 0v1h9V5a1 1 0 0 1 2 0v1zM6 11v8h13v-8H6z","fill":"currentColor","fillRule":"nonzero"}));
}

CalendarMenu.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = CalendarMenu;

CalendarMenu.default = CalendarMenu;
